import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HIDDEN_PATHS = ["/consultation", "/owner", "/owner/login"];

export default function StickyMobileCta() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hidden = HIDDEN_PATHS.includes(pathname);

  return (
    <AnimatePresence>
      {show && !hidden && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="fixed inset-x-4 bottom-4 z-40 xl:hidden"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
          data-testid="sticky-mobile-cta"
        >
          <Link
            to="/consultation"
            data-testid="sticky-mobile-cta-btn"
            className="flex items-center justify-center gap-2.5 bg-bermuda px-6 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-navy shadow-2xl shadow-navy/40 transition-colors active:bg-ivory"
          >
            Book a Consultation <ArrowRight size={14} />
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
